import styled from '@emotion/styled';

import { boxProps } from 'components/helpers';

export default {
  Box: styled.div`
    ${boxProps}
  `
};
